/* eslint-disable no-restricted-imports */
import { Deposit } from './actions/deposit';
import { Withdraw } from './actions/withdraw';
var actions = {
    Deposit: Deposit,
    Withdraw: Withdraw,
};
var Yearn = {
    actions: actions,
};
export { Yearn };
